import st from "lib/utils/index";
import { CustomerDecorator, CustomerFullDecorator } from "lib/decorators/index";
import BaseRepository from "./BaseRepository";

export const serializeCustomer = (data, initialData) => data;

export default new (class CustomersRepository extends BaseRepository {
  findAll(params = {}) {
    const bucket = this.getBucket("customers.index");
    const request$ = this.api.get(`/customers`, { params }).map((response) => ({
      records: st.api
        .dejsonapinize(response.data.data, response.data.included)
        .map((customer) => new CustomerDecorator(customer)),
      meta: response.data.meta,
    }));
    return this.mergeRequestWithCurrentBucketState(bucket, request$);
  }

  find(id) {
    return this.api
      .get(`/customers/${id}`)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((customer) => new CustomerFullDecorator(customer));
  }

  create(data) {
    return this.api
      .post(`/customers`, {
        customer: serializeCustomer(data),
      })
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((customer) => new CustomerFullDecorator(customer));
  }

  update(data, initialData) {
    return this.api
      .put(`/customers/${data.id}`, {
        customer: serializeCustomer(data, initialData),
      })
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((customer) => new CustomerFullDecorator(customer));
  }

  delete(id) {
    return this.api.delete(`/customers/${id}`);
  }
})();



// WEBPACK FOOTER //
// ./src/lib/repositories/CustomersRepository.js